import type { GetSchemeListSchemeGetQueryParams } from "kubb";
import type React from "react";
import { removeMapBlanks } from "../../../utils/object";
import { SearchParamParser } from "../../assetRegister/assets/list/AssetListSearchParam";

export function SchemeListSearchParam(props: {
  initialState: Partial<GetSchemeListSchemeGetQueryParams>;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <SearchParamParser
      {...props}
      parser={(parsed) =>
        removeMapBlanks({
          text_search: parsed.text_search as string | undefined,
          max_items: parsed.max_items
            ? Number.parseInt(parsed.max_items as string, 10)
            : undefined,
        })
      }
    />
  );
}
